import { FunctionComponent } from 'react';
import cn from 'classnames';
import { ShopCollection } from '@/types';
import { t } from '@/utils/i18n';
import { Close } from '@/components/common/icons/Close';
import './ShopCollectionList.scss';

type Props = {
  collections: ShopCollection[];
  selectedCollection?: ShopCollection | undefined;
  onCollectionClick: (category: ShopCollection | undefined) => void;
};

export const ShopCollectionList: FunctionComponent<Props> = ({
  collections,
  selectedCollection,
  onCollectionClick,
}) => {
  if (!collections.length) {
    return null;
  }

  const categoryItems = collections.map((collection) => {
    const active = selectedCollection && selectedCollection.id === collection.id;
    return (
      <li
        key={collection.id}
        className={cn('shop-collections__item', {
          'shop-collections__item--selected': active,
        })}
      >
        <button
          type="button"
          onClick={() => (active ? onCollectionClick(undefined) : onCollectionClick(collection))}
        >
          {collection.name}
        </button>
      </li>
    );
  });

  return (
    <div className="shop-collections">
      <div className="shop-collections__header">
        <h4 className="shop-collections__heading">{t('designSelector.categories')}</h4>
        {selectedCollection && (
          <button
            type="button"
            className="shop-collections__reset"
            onClick={() => onCollectionClick(undefined)}
          >
            <div>
              {t('designSelector.reset')}
              <Close width=".5em" height=".5em" />
            </div>
          </button>
        )}
      </div>
      <ul>{categoryItems}</ul>
    </div>
  );
};
